import ready from './ready'
import consoleLogger from '../services/consoleLogger.js'

export default function listenForReload() {
  const handleReload = event => {
    if (event.data?.type === 'RELOAD') {
      window.location.reload()
    }
    if (event.data?.type === 'CONSOLE_LOG') {
      const { level = 'log', message = '', data = [], location = null } = event.data.payload || {}
      consoleLogger.logFromServiceWorker(level, message, data, location)
    }
  }

  ready()
    .then(async registration => {
      if (registration) {
        navigator.serviceWorker?.addEventListener('message', handleReload)
      }
    })
    
  // Return remove listener callback
  return () => {
    ready()
      .then(async registration => {
        if (registration) {
          navigator.serviceWorker?.removeEventListener('message', handleReload)
        }
      })
  }
}
